const domain = "accenture.com"
export const expertsData = [
    {       
       "name": "Praveen Rajaram",
       "ename": "praveen_rajaram",
       "email": `praveen.rajaram@${domain}`,
       "role": "L&TT Lead - EIT, Entry Level, QE, Mainframe, RPA",
       "skill-sets": [
            "SAP SD"
       ],
       "certification-acquired": [
            "SI Certified Delivery Lead",
            "Certified Solution Consultant on Supply Chain Management by SAP AG",
            "Certified Solution Consultant on SAP CRM by SAP AG",
            "ITIL Certified",
            "Certified Design Thinking coach"
       ]
    },
    {        
        "name": "Madhuri Gattu",
        "ename": "madhuri_gattu",
        "email": `madhuri.gattu@${domain}`,
        "role": "L&TT Lead - Oracle ",
        "skill-sets": [
            "Oracle HCM Cloud",
            "Oracle PL/SQL"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2021 Foundations Associate",
            "Oracle Global Human Resources Cloud 2022 Implementation Professional"
        ]
    },
    {        
        "name": "Raji Raghunath",
        "ename": "raji_raghunath",
        "email": `raji.raghunath@${domain}`,
        "role": "L&TT Lead - SA, Aarambh",
        "skill-sets": [
            "Oracle DB", 
            "OCI", 
            "Weblogic Server",
            "Sailpoint"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Foundations Associate"
        ]
    },
    {        
        "name": "Arun Ragul A",
        "ename": "arun_ragul_arasan",
        "email": `arun.ragul.arasan@${domain}`,
        "role": "L&TT,Oracle PL/SQL, Oracle Apps,Siebel Expert",
        "skill-sets": [
            "Oracle Core",
            "Oracle Apps",
            "Siebel",
            "Oracle OCI"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Architect Associate",
            "Oracle Cloud Infrastructure 2022 Foundations Associate"
        ]
    },
    {        
        "name": "Amita Ahuja",
        "ename": "amita_ahuja",
        "email": `amita.ahuja@${domain}`,
        "role": "L&TT,Oracle PL/SQL, Oracle Apps Expert",
        "skill-sets": [
            "Oracle SQL",
            "PL/SQL",
            "Oracle Apps"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Foundations Associate"
        ]
    },
    {        
        "name": "Devika Gajanan Pote",
        "ename": "devika_gajanan_pote",
        "email": `devika.gajanan.pote@${domain}`,
        "role": "L&TT Lead - Oracle ULS and Certification Drive management",
        "skill-sets": [
            "Program Control Services",
            "Program and Project Management", 
            "SAP FICA"
        ],
        "certification-acquired": [
            "Prince 2",
            "ITIL Foundation",
            "Oracle Cloud Infrastructure Foundations 2021 Associate"
        ]
    },
    {        
        "name": "Joita Auddy",
        "ename": "joita_auddy",
        "email": `joita.auddy@${domain}`,
        "role": "L&TT,Oracle Apps DBA, Oracle PL/SQL Expert",
        "skill-sets": [
            "Oracle SQL",
            "Oracle PLSQL",
            "Oracle CORE"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Certified Foundations Associate"
        ]
    },
    {        
        "name": "Meenal Yogesh Lekhak",
        "ename": "meenal_yogesh_lekhak",
        "email": `meenal.yogesh.lekhak@${domain}`,
        "role": "L&TT,Oracle Peoplesoft,PLSQL",
        "skill-sets": [
            "Oracle Peoplesoft",
            "PLSQL",
            "Oracle Apps"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Foundations Associate",
            "Oracle Cloud Data Management 2022 Foundations Associate"
        ]
    },
    {        
        "name": "Mohit Sai Kumar Suryadevara",
        "ename": "mohit_s_suryadevara",
        "email": `mohit.s.suryadevara@${domain}`,
        "role": "L&TT,Oracle DB, Oracle Apps Expert",
        "skill-sets": [
            "Oracle Apps",
            "Oracle DB",
            "Oracle Cloud"
        ],
        "certification-acquired": [
            "Oracle Cloud Data Management Foundations Associate",
            "Oracle Cloud Infrastructure Foundations Associate",
            "Oracle Autonomous Database Cloud Certified Professional"
        ]
    },
    {        
        "name": "Parvathy Selvam",
        "ename": "parvathy_selvam",
        "email": `parvathy.selvam@${domain}`,
        "role": "L&TT,Oracle PL/SQL , MySQL Expert",
        "skill-sets": [
            "Oracle Core",
            "MYSQL"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure Foundations Associate 2022"
        ]
    },    
    {        
        "name": "Peenaaz Amreen",
        "ename": "peenaaz_amreen",
        "email": `peenaaz.amreen@${domain}`,
        "role": "L&TT,Oracle PL/SQL, Oracle Autonomous DB Expert",
        "skill-sets": [
            "SQL", 
            "PL/SQL"
        ],
        "certification-acquired": [
            "Oracle Cloud Data Management Foundations Associate",
            "Oracle Cloud Infrastructure Foundations Associate"
        ]
    },                                      
    {       
       "name": "Sandesh Kudtarkar",
       "ename": "sandesh_m_kudtarkar",
       "email": `sandesh.m.kudtarkar@${domain}`,
       "role": "L&TT,Siebel, Oracle SQL  Expert",
       "skill-sets": [
            "Siebel", 
            "HTML", 
            "CSS", 
            "JS", 
            "OCI Foundations", 
            "Communication"            
       ],
       "certification-acquired": [
            "ITIL 4 Foundation",
            "Oracle Cloud Data Management 2022 Foundations Associate",
            "Oracle Cloud Infrastructure Foundations Associate 2023"
       ]
    },
    {        
        "name": "Subhojyoti Mukherjee",
        "ename": "subhojyoti_mukherjee",
        "email": `subhojyoti.mukherjee@${domain}`,
        "role": "L&TT,Oracle PL/SQL Expert",
        "skill-sets": [
            "Oracle SQL",
            "PLSQL",
            "Oracle CORE"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Architect Associate",
            "Oracle Cloud Infrastructure 2022 Foundations Associate",
            "Dale Carnegie Certification"
        ]
    },
    {        
        "name": "Sudipta Das",
        "ename": "sudipta_i_das",
        "email": `sudipta.i.das@${domain}`,
        "role": "L&TT,Oracle PL/SQL Expert",
        "skill-sets": [
            "Oracle SQL",
            "PLSQL",
            "Oracle Core"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Foundations Associate\nOracle Cloud Data Management Foundations Associate (2022)"
        ]
    },
    {        
        "name": "Suganya Balasubramaniam",
        "ename": "s_ai_balasubramaniam",
        "email": `s.ai.balasubramaniam@${domain}`,
        "role": "L&TT,Oracle PL/SQL Expert",
        "skill-sets": [
            "SQL",
            "PLSQL"
        ],
        "certification-acquired": []
    },
    {        
        "name": "Taher Iqbal Mohammed",
        "ename": "taher_iqbal_mohammed",
        "email": `taher.iqbal.mohammed@${domain}`,
        "role": "L&TT,Oracle PL/SQL, Oracle Apps Expert",
        "skill-sets": [
            "Oracle APPS",
            "Oracle Core",
            "SQL",
            "PLSQL"   
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Foundations Associate"
        ]
    },    
    {        
        "name": "Vinod Pragadeesh M",
        "ename": "vinod_manoharan",
        "email": `Vinod.Manoharan@${domain}`,
        "role": "L&TT,SOA, OSB, C++ Expert",
        "skill-sets": [
            "Oracle Core", 
            "Oracle Apps", 
            "SOA", 
            "OSB", 
            "Client Server (C++)", 
            "Unix", 
            "SSIS", 
            "SSRS"
        ],
        "certification-acquired": [
            "Oracle SOA Suite Certified Implementation Specialist",
            "Oracle Data Integrator 12C Certified Implementation Specialist",
            "Green Software for Practitioners ( LFC131 )",
            "Oracle Cloud Infrastructure 2022 Certified Foundations Associate",
            "Dale Carnegie Certification "
        ]
    },
    {        
        "name": "Vidyanand Aelgani",
        "ename": "Vidyanand_aelgani",
        "email": `Vidyanand.aelgani@${domain}`,
        "role": "L&TT,Oracle DB, Oracle Apps, Oracle OCI, Oracle Procurement Cloud Expert",
        "skill-sets": [
            "Oracle DB", 
            "Oracle Apps", 
            "Oracle OCI", 
            "Oracle Procurement Cloud"
        ],
        "certification-acquired": [
            "Oracle Cloud Infrastructure 2022 Architect Professional",
            "Oracle Cloud Platform Application Integration 2022 Professional",
            "Oracle Cloud Infrastructure 2022 Architect Associate",
            "Oracle Cloud Infrastructure 2022 Foundations Associate",
            "Oracle Cloud Infrastructure 2021 Architect Professional",
            "Oracle Cloud Infrastructure 2021 Architect Associate",
            "Oracle Cloud Database Services 2021 Specialist",
            "Oracle Cloud Infrastructure Foundations 2021 Associate",
            "Oracle Autonomous Database Cloud 2021 Specialist",
            "Oracle Cloud Platform Application Integration 2021 Specialist"
        ]
    }                      
]